import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ChallengesService {

  claims;

  constructor(
    private authService: AuthService,
    private firestore: AngularFirestore,
    private storageService: StorageService
  ) {
      this.getClaims();
  }


  async getClaims(){
    try {
      this.claims = await this.storageService.get('gnx-claims');
      return this.claims;
    } catch (error) {
      throw new Error(error);
    }
  }

  getChallengeUser(id) {
    try {
      const uid = (this.authService.userGnxId) ? this.authService.userGnxId : this.claims.uid;
      return this.firestore
        .collection(`/ChallengeUsers/${uid}/Challenges`)
        .doc(id)
    } catch (error) {
      console.log("error get user info",error);
      throw new Error(error);
    }
  }
}
